const actions = {
  GET_RESERVATIONS_HISTORY_REQUEST: "GET_RESERVATIONS_HISTORY_REQUEST",
  GET_RESERVATIONS_HISTORY_SUCCESS: "GET_RESERVATIONS_HISTORY_SUCCESS",
  GET_RESERVATIONS_HISTORY_FAILURE: "GET_RESERVATIONS_HISTORY_FAILURE",
  UPDATE_RESERVATION_TOUCHSALE_SUM_REQUEST:
    "UPDATE_RESERVATION_TOUCHSALE_SUM_REQUEST",
  UPDATE_RESERVATION_TOUCHSALE_SUM_SUCCESS:
    "UPDATE_RESERVATION_TOUCHSALE_SUM_SUCCESS",
  UPDATE_RESERVATION_TOUCHSALE_SUM_FAILURE:
    "UPDATE_RESERVATION_TOUCHSALE_SUM_FAILURE",

  getReservationsHistory: (getReservationHistoryData) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_RESERVATIONS_HISTORY_REQUEST,
        getReservationHistoryData,
      });
    };
  },

  updateReservationTouchsaleSum: (
    updateReservationTouchsaleSumData,
    refreshReservationHistoryData
  ) => {
    return (dispatch) => {
      dispatch({
        type: actions.UPDATE_RESERVATION_TOUCHSALE_SUM_REQUEST,
        updateReservationTouchsaleSumData,
        refreshReservationHistoryData,
      });
    };
  },
};

export default actions;
